<script setup lang="ts">
</script>

<template>
  <ul class="brand-list">
    <slot />
  </ul>
</template>

<style scoped>
.brand-list {
  list-style: none !important;
  padding-left: 1.25rem !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 0.5rem !important;
}

.brand-list :deep(> li) {
  position: relative;
  padding-left: 0 !important;
}

.brand-list :deep(> li)::before {
  content: '';
  position: absolute;
  left: -1.25rem;
  top: 0.45em;
  width: 0.8rem;
  height: 0.8rem;
  background-color: var(--ui-color-primary-500);
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-25 -15 120 130'%3E%3Cpath d='M70,34.9c0-0.7-0.4-1.4-1-1.8L16.7,2.9c-1-0.6-2-0.7-2.2-0.2L2.1,23.9c-0.2,0.4,0.3,1.2,1.3,1.8l42,24.3L3.6,74.2c-1.1,0.6-1.7,1.5-1.5,1.9l12.3,21.3c0.2,0.4,1.3,0.3,2.4-0.3L68.9,67c0.6-0.4,1-1.1,1-1.8V34.9z'/%3E%3C/svg%3E");
  mask-size: contain;
  mask-repeat: no-repeat;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-25 -15 120 130'%3E%3Cpath d='M70,34.9c0-0.7-0.4-1.4-1-1.8L16.7,2.9c-1-0.6-2-0.7-2.2-0.2L2.1,23.9c-0.2,0.4,0.3,1.2,1.3,1.8l42,24.3L3.6,74.2c-1.1,0.6-1.7,1.5-1.5,1.9l12.3,21.3c0.2,0.4,1.3,0.3,2.4-0.3L68.9,67c0.6-0.4,1-1.1,1-1.8V34.9z'/%3E%3C/svg%3E");
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
}
</style>
